// File: assets/product-image-carousel.js

class ProductImageCarousel {
  constructor(container) {
    this.container = container;
    this.images = JSON.parse(this.container.dataset.images || '[]');
    this.currentIndex = 0;
    this.render();
    this.attachEventListeners();
  }

  render() {
    const image = this.images[this.currentIndex];
    const productTitle = this.container.dataset.productTitle;
    
    this.container.innerHTML = `
      <div class="relative overflow-hidden">
        <div class="aspect-w-1 aspect-h-1 w-full">
          <img
            src="${image || "/placeholder.svg"}"
            alt="${productTitle} - Image ${this.currentIndex + 1}"
            class="object-cover w-full h-full"
          />
        </div>
        <div class="absolute bottom-2 right-2 flex space-x-2">
          <button class="carousel-prev bg-white bg-opacity-70 p-1 rounded-full hover:bg-opacity-100 transition-opacity">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-4 h-4 text-gray-800">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button class="carousel-next bg-white bg-opacity-70 p-1 rounded-full hover:bg-opacity-100 transition-opacity">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" class="w-4 h-4 text-gray-800">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    `;
  }

  attachEventListeners() {
    const prevButton = this.container.querySelector('.carousel-prev');
    const nextButton = this.container.querySelector('.carousel-next');

    prevButton.addEventListener('click', () => this.prevImage());
    nextButton.addEventListener('click', () => this.nextImage());
  }

  nextImage() {
    this.currentIndex = (this.currentIndex + 1) % this.images.length;
    this.render();
    this.attachEventListeners();
  }

  prevImage() {
    this.currentIndex = (this.currentIndex - 1 + this.images.length) % this.images.length;
    this.render();
    this.attachEventListeners();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const carousels = document.querySelectorAll('.product-image-carousel');
  carousels.forEach(carousel => new ProductImageCarousel(carousel));
});